"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketLifecycleOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketLifecycleOutput.js.map